import React from 'react'
import ContentBox from '../../../common/ContentBox'
import { Box, Divider, Typography } from '@mui/material'
import { FundItem } from '../../../../models/Fund'
import FundTeamItemCard from './FundTeamItemCard';
import { useTranslation } from 'react-i18next';
import FavoriteFundButton from '../../FavoriteFundButton';

export interface IFundTeamTabContentProps {
  fund: FundItem;
}

const FundTeamTabContent: React.FC<IFundTeamTabContentProps> = ({ fund }) => {
  const { t } = useTranslation();
  const dataToShow = fund.teams.slice(0, 4);
  return <ContentBox proportion={1}>
    <Box display={"flex"} flexDirection={"column"} gap={"20px"}>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('LibraryOfFundFundTeamTabTitle')}</Typography>
        <FavoriteFundButton fundId={fund.id} />
      </Box>
      <Box display={"flex"} gap={"33px"}>
        {dataToShow.map((t, i) => <>
          <FundTeamItemCard member={t} key={`fundteam-${t.id}`} />
          {dataToShow.length !== i + 1 && <Divider orientation="vertical" flexItem key={`divider-${t.id}`}/>}
        </>)}
      </Box>
    </Box>
  </ContentBox>
}

export default FundTeamTabContent